export const minTurnoverValue = 1000;
export const minNumberOfMatches = 10;
export const literals = {
  'sortLabel'    : {
    'el': 'Ταξινόμηση με βάση: ',
    'en': 'Sort By: '
  },
  'timestamp'    : {
    'el': 'Ώρα Έναρξης',
    'en': 'Time'
  },
  'timezone_label': {
    'el': 'Ζώνη Ώρας',
    'en': 'Timezone'
  },
  'turnover_1x2' : {
    'el': 'Μεγαλύτερο Τζίρο (1-Χ-2)',
    'en': '1x2 Volume'
  },
  'turnover_1m'  : {
    'el': 'Μεγαλύτερο Τζίρο στον άσσο',
    'en': '1 Volume'
  },
  'turnover_Xm'  : {
    'el': 'Μεγαλύτερο τζίρο στην ισοπαλία',
    'en': 'X Volume'
  },
  'turnover_2m'  : {
    'el': 'Μεγαλύτερο τζίρο στο διπλό',
    'en': '2 Odds'
  },
  'odd_1'        : {
    'el': 'Μεγαλύτερο άσο',
    'en': '1 Odds'
  },
  'odd_X'        : {
    'el': 'Μεγαλύτερο Χ',
    'en': 'X odds'
  },
  'odd_2'        : {
    'el': 'Μεγαλύτερο διπλό',
    'en': '2 Odds'
  },
  'odd_ou'       : {
    'el': 'Μεγαλύτερο τζίρο (Under/Over)',
    'en': 'Under/Over Volume'
  },
  'turnover_um'  : {
    'el': 'Μεγαλύτερο τζίρο στο Under',
    'en': 'Under Volume'
  },
  'turnover_om'  : {
    'el': 'Μεγαλύτερο τζίρο στο Over',
    'en': 'Over Volume'
  },
  'odd_u'        : {
    'el': 'Μεγαλύτερο Under',
    'en': 'Under Volume'
  },
  'odd_o'        : {
    'el': 'Μεγαλύτερο Over',
    'en': 'Over Volume'
  },
  'odds_label'   : {
    'el': 'Αποδόσεις',
    'en': 'Odds Format: '
  },
  'dec'          : {
    'el': 'Δεκαδικές',
    'en': 'Decimal'
  },
  'fra'          : {
    'el': 'Κλασματικές',
    'en': 'Fractional'
  },
  'mon'             : {
    'el': 'Αμερικάνικιες',
    'en': 'Moneyline'
  },
  'currency_label'  : {
    'el': 'Νόμισμα',
    'en': 'Currency'
  },
  'eur'          : {
    'el': 'Ευρώ',
    'en': 'Euro'
  },
  'gbp'          : {
    'el': 'Στερλίνα',
    'en': 'British Pounds'
  },
  'usd'          : {
    'el': 'Δολάριο',
    'en': 'US Dollars'
  },
  'tziros'       : {
    'el': 'ΤΖΙΡΟΣ',
    'en': 'VOLUME'
  },
  'match'        : {
    'el':'Αγώνας',
    'en':'Match'
  },
  'startTime'        : {
    'el':'Ω/Ε',
    'en':'TIME'
  },
  'comp'            :{
    'el':'Δ',
    'en':'C'
  },
  'readPreview'     :{
    'el': 'Διάβασε την ανάλυση',
    'en': 'Read the match preview',
  },
  'corsMessage'     :{
    'el': 'Η υπηρεσία είναι απενεργοποιημένη για τον ιστότοπό σας, παρακαλώ επικοινωνήστε μαζί μας στο support@betwidgets.com',
    'en': 'This service is unavailable for your website, please contact us at support@betwidgets.com'
  }

}


// WEBPACK FOOTER //
// ./src/constants.js